// Draggable floating panels — self-contained adaptation of the upstream
// mapUtils.makeDraggable (same convention: drag by header, ignore interactive targets).

export function makeDraggable(panel, handle) {
  if (!panel || !handle) return;
  if (panel.__dragCleanup) panel.__dragCleanup();

  let offsetX = 0, offsetY = 0, isDown = false, activePointerId = null;
  handle.style.cursor = 'move';
  handle.style.touchAction = 'none';

  const isInteractive = (t) => t?.closest?.('button, input, select, textarea, a, label, [data-no-drag]');
  const getPoint = (e) => e.touches?.[0] || e.changedTouches?.[0] || e;

  const onStart = (e) => {
    if ((e.button ?? 0) !== 0 || isInteractive(e.target)) return;
    isDown = true;
    activePointerId = e.pointerId ?? null;
    const rect = panel.getBoundingClientRect();
    const p = getPoint(e);
    offsetX = p.clientX - rect.left;
    offsetY = p.clientY - rect.top;
    panel.style.setProperty('left', `${rect.left}px`, 'important');
    panel.style.setProperty('top', `${rect.top}px`, 'important');
    panel.style.setProperty('right', 'auto', 'important');
    panel.style.setProperty('bottom', 'auto', 'important');
    panel.classList.add('is-dragging');
    handle.setPointerCapture?.(activePointerId);
    e.preventDefault();
  };
  const onMove = (e) => {
    if (!isDown) return;
    if (activePointerId !== null && e.pointerId !== activePointerId) return;
    const p = getPoint(e);
    const margin = 8;
    const left = Math.min(Math.max(margin, p.clientX - offsetX), Math.max(margin, window.innerWidth - panel.offsetWidth - margin));
    const top = Math.min(Math.max(margin, p.clientY - offsetY), Math.max(margin, window.innerHeight - panel.offsetHeight - margin));
    panel.style.setProperty('left', `${left}px`, 'important');
    panel.style.setProperty('top', `${top}px`, 'important');
  };
  const onEnd = () => { isDown = false; activePointerId = null; panel.classList.remove('is-dragging'); };

  handle.addEventListener('pointerdown', onStart);
  window.addEventListener('pointermove', onMove);
  window.addEventListener('pointerup', onEnd);

  panel.__dragCleanup = () => {
    handle.removeEventListener('pointerdown', onStart);
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onEnd);
  };
}
